import { goToErrorsView } from 'actions/errorViewNavigation';

require('sass/blocks/personal-data-view.scss');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
//@actions
const stepsActions = require('actions/stepsActions');
const preLoaderActions = require('actions/preLoaderActions');
const formActions = require('react-redux-form').actions;
const cardImagesActions = require('actions/cardImagesActions');
const configCardActions = require('actions/configCardActions');
// @ components
const CardSelector = require('components/commons/cardSelector/cardSelector');
const Headline = require('components/headline');
//@utilities
import { FormattedText } from 'core/i18n';
const { PAGE_PRODUCT, errorTag } = require('utilities/uTagging');
// @ constants
const {
    ERROR_AL_CONFIGURAR_TARJETA_DE_DEBITO,
    ERROR_AL_ACTUALIZAR_TARJETA_DEBITO,
} = require('constants/analyticsErrors');

class HomeAbroadConfigCard extends React.Component {
    constructor(props) {
        super(props);

        this.getHomeAbroadCards = this.getHomeAbroadCards.bind(this);
        this.onHandleSave = this.onHandleSave.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { cardImages, cardImagesActions, userProfile } = this.props;

        if (cardImages.get('cardImagesArray').size === 0) {
            cardImagesActions.getCardImages(userProfile.accessToken);
        }
    }

    getHomeAbroadCards() {
        const { cardImages } = this.props;

        const homeAbroadCards = [];
        cardImages.get('cardImagesArray').map(function (value) {
            homeAbroadCards.push(value.toObject());
        });

        return homeAbroadCards;
    }

    onHandleSave(value) {
        const { userProfile, configCardActions, goToErrorsView } = this.props;
        const data = value;
        const accessToken = userProfile.accessToken;

        if (userProfile.debitCard) {
            const cardConfigId = userProfile.debitCard.id;
            configCardActions.updateDebit(cardConfigId, data, accessToken, (saved, errors) => {
                if (!saved) {
                    if (errors['6002']) {
                        goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_ACTUALIZAR_TARJETA_DEBITO });
                    }
                }
            });
        } else {
            configCardActions.saveDebit(data, accessToken, (saved, error) => {
                if (!saved) {
                    if (error.body.errors['6002']) {
                        goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_CONFIGURAR_TARJETA_DE_DEBITO });
                    }
                }
                errorTag(error.body, PAGE_PRODUCT, ERROR_AL_CONFIGURAR_TARJETA_DE_DEBITO, error.statusCode);
            });
        }
    }

    render() {
        const cardImages = this.getHomeAbroadCards();
        const onHandleSave = this.onHandleSave;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        let cardSelectorComponent;

        if (cardImages.length > 0) {
            cardSelectorComponent = (
                <CardSelector
                    images={cardImages}
                    disabled={disabled}
                    profileModelID="userProfile.homeAbroadCardSelectedId"
                    profileModelCode="userProfile.homeAbroadCardSelectedCode"
                    cardImageUrlModel="userProfile.cardImageUrl"
                    label="cardSelector-homeAbroadTitle"
                    formActions={this.props.formActions}
                    onHandleSave={onHandleSave}
                    userProfile={this.props.userProfile}
                />
            );
        }

        return (
            <div className="prospects-step-content basic-layering">
                <Headline icon="tarjeta" className="prospects-gutter">
                    <h2>
                        <FormattedText value="stepsTitles-cardSelector" />
                    </h2>
                </Headline>
                <div className="personal-data-view" style={{ height: 400 }}>
                    {cardSelectorComponent}
                </div>
            </div>
        );
    }
}

module.exports.constructor = HomeAbroadConfigCard;
module.exports.HomeAbroadConfigCard = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        cardImages: state.cardImages,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
        configCardActions: bindActionCreators(configCardActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(HomeAbroadConfigCard);
